"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Label_1 = require("components/Label");
var DatePicker_1 = require("components/DatePicker");
var mobx_1 = require("mobx");
var dateToString_1 = require("lib/functions/dateToString");
var Signature_1 = require("components/Signature");
var findErrors_1 = require("lib/functions/findErrors");
var rules = {
    signature: { presence: { allowEmpty: false, message: "is required" } }
};
var SignatureBox = (function (_super) {
    __extends(SignatureBox, _super);
    function SignatureBox(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.json_data.date = dateToString_1.jsDateToMySQLDate(new Date());
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    SignatureBox.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    SignatureBox.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateSignature", this.isValid);
                return [2];
            });
        });
    };
    SignatureBox.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateSignature");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    SignatureBox.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    SignatureBox.prototype.isValid = function () {
        console.log("Validate Signature");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", this.errors);
        return isValid;
    };
    SignatureBox.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "Disclaimer and Signature"),
            React.createElement("h3", { className: "sub-title" }, "I certify that my answers are true and complete to the best of my knowledge."),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-xs-6" },
                    React.createElement(Signature_1.Signature, { id: "signature", onChange: this.onChange, model: this.props.model, errors: this.errors })),
                React.createElement("div", { className: "col-xs-6" },
                    React.createElement(Label_1.Label, { htmlFor: "date", text: "Date", required: true }),
                    React.createElement(DatePicker_1.DatePicker, { id: "date", json_data: json_data, onChange: onChange, errors: errors, disabled: true })))));
    };
    __decorate([
        mobx_1.observable
    ], SignatureBox.prototype, "errors", void 0);
    return SignatureBox;
}(react_1.Component));
exports.SignatureBox = SignatureBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2lnbmF0dXJlQm94LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvQXBwbGljYXRpb24vcGFydHMvU2lnbmF0dXJlQm94L1NpZ25hdHVyZUJveC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUE4QjtBQUM5QiwrQkFBK0I7QUFFL0IsMENBQXNDO0FBQ3RDLG9EQUFnRDtBQUNoRCw2QkFBK0I7QUFDL0IsMkRBQTREO0FBQzVELGtEQUE4QztBQUM5Qyx1REFBbUQ7QUFNbkQsSUFBTSxLQUFLLEdBQUc7SUFDVixTQUFTLEVBQUUsRUFBQyxRQUFRLEVBQUUsRUFBQyxVQUFVLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxhQUFhLEVBQUMsRUFBQztDQUNyRSxDQUFBO0FBRUQ7SUFBa0MsZ0NBQW9CO0lBS2xELHNCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FTZjtRQVpPLFlBQU0sR0FBNEIsRUFBRSxDQUFBO1FBS3hDLEtBQUksQ0FBQyxRQUFRLEdBQUcsS0FBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsS0FBSSxDQUFDLENBQUE7UUFDeEMsS0FBSSxDQUFDLFNBQVMsR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQTtRQUN0QyxLQUFJLENBQUMsU0FBUyxDQUFDLElBQUksR0FBRyxnQ0FBaUIsQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDLENBQUE7UUFFbkQsS0FBSSxDQUFDLE9BQU8sR0FBRyxLQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTtRQUN0QyxLQUFJLENBQUMsT0FBTyxHQUFHLEtBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUksQ0FBQyxDQUFBO1FBQ3RDLEtBQUssQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLFdBQVcsQ0FBQyxLQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7O0lBQ3BELENBQUM7SUFFTyw4QkFBTyxHQUFmO1FBQ0ksSUFBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUE7UUFDM0MsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFWSx3Q0FBaUIsR0FBOUI7OztnQkFDSSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUE7Z0JBQ3RDLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLG1CQUFtQixDQUFDLG1CQUFtQixFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTs7OztLQUMxRTtJQUVZLDJDQUFvQixHQUFqQzs7O2dCQUNJLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLHNCQUFzQixDQUFDLG1CQUFtQixDQUFDLENBQUE7Z0JBQzVELElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFBOzs7O0tBQzNEO0lBRU8sK0JBQVEsR0FBaEIsVUFBaUIsRUFBVSxFQUFFLEtBQUs7UUFDOUIsSUFBSSxDQUFDLFNBQVMsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUE7UUFDMUIsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFTyw4QkFBTyxHQUFmO1FBQ0ksT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFBO1FBQzNCLElBQUEsbURBQXFELEVBQXBELG9CQUFPLEVBQUUsa0JBQTJDLENBQUE7UUFFM0QsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7UUFDcEIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxhQUFhLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBRXZDLE9BQU8sT0FBTyxDQUFBO0lBQ2xCLENBQUM7SUFFTSw2QkFBTSxHQUFiO1FBQ1UsSUFBQSxTQUFvQyxFQUFuQyx3QkFBUyxFQUFFLHNCQUFRLEVBQUUsa0JBQWMsQ0FBQTtRQUMxQyxPQUFPLENBQ0gsaUNBQVMsU0FBUyxFQUFDLGlCQUFpQjtZQUNoQyw0QkFBSSxTQUFTLEVBQUMsZUFBZSwrQkFBOEI7WUFDM0QsNEJBQUksU0FBUyxFQUFDLFdBQVcsbUZBRXBCO1lBQ0wsNkJBQUssU0FBUyxFQUFDLEtBQUs7Z0JBQ2hCLDZCQUFLLFNBQVMsRUFBQyxVQUFVO29CQUNyQixvQkFBQyxxQkFBUyxJQUNOLEVBQUUsRUFBQyxXQUFXLEVBQ2QsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRLEVBQ3ZCLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssRUFDdkIsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNLEdBQ3JCLENBQ0E7Z0JBQ04sNkJBQUssU0FBUyxFQUFDLFVBQVU7b0JBQ3JCLG9CQUFDLGFBQUssSUFBQyxPQUFPLEVBQUMsTUFBTSxFQUFDLElBQUksRUFBQyxNQUFNLEVBQUMsUUFBUSxTQUFHO29CQUM3QyxvQkFBQyx1QkFBVSxJQUNQLEVBQUUsRUFBQyxNQUFNLEVBQ1QsU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLFFBQVEsRUFDbEIsTUFBTSxFQUFFLE1BQU0sRUFDZCxRQUFRLEVBQUUsSUFBSSxHQUNoQixDQUNBLENBQ0osQ0FDQSxDQUNiLENBQUE7SUFDTCxDQUFDO0lBMUVEO1FBREMsaUJBQVU7Z0RBQ2lDO0lBMkVoRCxtQkFBQztDQUFBLEFBOUVELENBQWtDLGlCQUFTLEdBOEUxQztBQTlFWSxvQ0FBWSJ9